import React from 'react';
import { Navbar, Button, Dropdown } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const Topbar = () => {
    const { user, logout } = useAuth();

    return (
        <Navbar bg="white" className="border-bottom shadow-sm py-3">
            <div className="container-fluid px-4">
                <Navbar.Brand>
                    <h5 className="mb-0 text-dark">Dashboard</h5>
                </Navbar.Brand>

                <div className="d-flex align-items-center">
                    <div className="me-4">
                        <small className="text-muted me-2">Last login:</small>
                        <span>{new Date().toLocaleDateString()}</span>
                    </div>

                    <Dropdown align="end">
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className="d-flex align-items-center">
                            <div className="bg-success rounded-circle d-flex align-items-center justify-content-center me-2"
                                style={{ width: '32px', height: '32px' }}>
                                <span className="text-white">{user?.username?.charAt(0)?.toUpperCase() || 'A'}</span>
                            </div>
                            <span className="d-none d-md-inline">{user?.username || 'Admin'}</span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Header>
                                <div className="fw-bold">{user?.username || 'Admin'}</div>
                                <small className="text-muted">{user?.role || 'Super Admin'}</small>
                            </Dropdown.Header>
                            <Dropdown.Divider />
                            <Dropdown.Item href="#">
                                👤 My Profile
                            </Dropdown.Item>
                            <Dropdown.Item href="#">
                                ⚙️ Settings
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={logout} className="text-danger">
                                🚪 Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </Navbar>
    );
};

export default Topbar;